import React from 'react'
import ReactMarkdown from 'react-markdown'
import yaml from 'js-yaml'

import {Card, withStyles} from 'material-ui'

import Hero, {HeroContent} from './Hero'
import MainNav from './MainNav'
import TitledPage from './TitledPage'

import Hero2 from './Hero2'
import Cover from './Cover'
import HeroSection from './HeroSection'
import BodySection from './BodySection'
import SignupCard from './SignupCard'
import CaptionImage from './CaptionImage'

import drVisit from '../md/doctors-visit.md'
import medProblems from '../md/medicine-problems-to-avoid.md'
import emergencyRoom from '../md/emergency-room.md'
import onlineHealth from '../md/online-health-info.md'

const PAGES = {
    'doctors-visit': drVisit,
    'medicine-problems-to-avoid': medProblems,
    'emergency-room': emergencyRoom,
    'online-health-info': onlineHealth,
}

const RENDERERS = {
    linkReference: ({href, children, ...props}) => {
        if(href.startsWith('https://app.carefol.io')) {
            return <a href={href} rel="nofollow noreferrer noopener" target="_blank">{children}</a>
        } else {
            return <a href={href}>{children}</a>
        }
    },
    imageReference: CaptionImage,
}

const styles = theme => ({
    center: {
        display: 'block',
        margin: '0 auto',
    },
})

class _Page extends React.Component {

    constructor(...args) {
        super(...args)
        this.state = {
            cover: '',
            preview: '# Page not found',
            body: "Sorry, but I can't seem to find that page."}
    }

    componentDidMount = () => {
        const {match: {params: {pageId}}} = this.props
        this.loadContent(pageId)
    }

    loadContent = async(pageId) => {
        const pageUrl = PAGES[pageId]
        const resp = await fetch(PAGES[pageId])
        const text = await resp.text()
        const obj = yaml.safeLoad(text)
        this.setState(obj)
    }

    render() {
        const {cover, preview, body} = this.state
        const {classes} = this.props
        return (
            <TitledPage title="Carefol.io | Visiting the Doctor">
                <Hero2>
                    <Cover src={cover || "/img/helping-senior-with-technology_925x.jpg"} dark="0.5"/>
                    <HeroSection>
                        <ReactMarkdown source={preview}/>
                    </HeroSection>
                </Hero2>
                <BodySection>
                    <ReactMarkdown source={body} renderers={RENDERERS}/>
                    <h1>Ready to get started with Carefolio?</h1>
                </BodySection>
                <SignupCard className={classes.center}/>
            </TitledPage>
        )
    }

}

export const Page = withStyles(styles)(_Page)

export default Page


// WEBPACK FOOTER //
// ./src/components/Page.jsx